import { clampTime, formatDateFR } from './utils';

interface TimeInputsProps {
  asSingle: boolean;
  startDate: Date | null;
  endDate: Date | null;
  startHours: number;
  startMinutes: number;
  endHours: number;
  endMinutes: number;
  onStartHoursChange: (v: number) => void;
  onStartMinutesChange: (v: number) => void;
  onEndHoursChange: (v: number) => void;
  onEndMinutesChange: (v: number) => void;
}

function TimeGroup({
  label,
  hours,
  minutes,
  onHoursChange,
  onMinutesChange,
}: {
  label: string;
  hours: number;
  minutes: number;
  onHoursChange: (v: number) => void;
  onMinutesChange: (v: number) => void;
}) {
  const inputClass =
    'flex-1 min-w-0 rounded-lg border border-neutral-300 px-3 py-2 text-center text-sm font-medium text-dark-500 focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500';

  return (
    <div className="flex-1 min-w-0">
      <span className="mb-1.5 block text-xs font-medium text-dark-500">{label}</span>
      <div className="flex items-center gap-1.5">
        <input
          type="number"
          min={0}
          max={23}
          value={hours.toString().padStart(2, '0')}
          onChange={(e) => onHoursChange(clampTime(parseInt(e.target.value) || 0, 0, 23))}
          className={inputClass}
        />
        <span className="text-sm font-medium text-neutral-400 shrink-0">:</span>
        <input
          type="number"
          min={0}
          max={59}
          value={minutes.toString().padStart(2, '0')}
          onChange={(e) => onMinutesChange(clampTime(parseInt(e.target.value) || 0, 0, 59))}
          className={inputClass}
        />
      </div>
    </div>
  );
}

export function TimeInputs({
  asSingle,
  startDate,
  endDate,
  startHours,
  startMinutes,
  endHours,
  endMinutes,
  onStartHoursChange,
  onStartMinutesChange,
  onEndHoursChange,
  onEndMinutesChange,
}: TimeInputsProps) {
  return (
    <div className="border-t border-neutral-200 pt-4 mt-3">
      <div className="flex items-end gap-3">
        <TimeGroup
          label={asSingle ? (formatDateFR(startDate) || 'Heure') : (formatDateFR(startDate) || 'Début')}
          hours={startHours}
          minutes={startMinutes}
          onHoursChange={onStartHoursChange}
          onMinutesChange={onStartMinutesChange}
        />
        {!asSingle && (
          <>
            <span className="pb-2.5 text-sm text-neutral-400 shrink-0">à</span>
            <TimeGroup
              label={formatDateFR(endDate) || 'Fin'}
              hours={endHours}
              minutes={endMinutes}
              onHoursChange={onEndHoursChange}
              onMinutesChange={onEndMinutesChange}
            />
          </>
        )}
      </div>
    </div>
  );
}
